import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux"; // <-- Importa aquí
import { getUser, updateUserProfile, getUserCourses, LogoutUser } from "../../redux/actions/actions";
import Modal from "../modal/Modal";
import { NavLink, useNavigate } from "react-router-dom";
import { Card, Button, Row, Col } from 'react-bootstrap';
import useSessionChecker from '../../hooks/useSessionChecker';
import './profile.css';
import mariela from '../../assets/img/user.jpg'

const Profile = () => {
    useSessionChecker();
    const navigate = useNavigate();
    const [isModal, setModal] = useState(false);
    const [userData, setUserData] = useState({});

    // Hacemos la peticion de informacion del usuario
    const userCredentials = useSelector((state) => state.credentials);

    const dispatch = useDispatch();
    const userProfile = useSelector((state) => state.user);
    const userCourses = useSelector((state) => state.userCourses);

    useEffect(() => {
        dispatch(getUser(userCredentials.token));
    }, [dispatch, userCredentials.token]);

    // Sincronizamos los datos del usuario con el estado
    useEffect(() => {
        if (isModal && userProfile) {
            setUserData(userProfile);
        }
    }, [isModal, userProfile]);

    // Este useEffect carga los cursos del usuario.
    useEffect(() => {
        console.log('Iniciado de carga de cursos del usuario con token:', userCredentials.token);

        if (userCredentials.token) {
            dispatch(getUserCourses(userCredentials.token));
        }
    }, [dispatch, userCredentials.token]);

    const user = {
        name: (userProfile.firstName ? userProfile.firstName : "") + ' ' + (userProfile.lastName ? userProfile.lastName : ''),
        email: userProfile.email || '',
        phone: userProfile.phone || '',
        birthdate: userProfile.birthDate
    };
    // Función para manejar el cambio de datos del usuario
    const handleChange = (e) => {
        const { name, value } = e.target;
        setUserData({
            ...userData,
            [name]: value
        });
        console.log('Datos del usuario actualizados:', userData);
        // Aquí puedo agregar la lógica para habilitar el botón de actualización
    }

    // Función para manejar la actualización del perfil
    const handleUpdateProfile = () => {
        dispatch(updateUserProfile(userData, userCredentials.token));
        setModal(false);
    }

    // Funcion para cerrar sesión
    const handleLogout = () => {
        dispatch(LogoutUser(navigate));
    }

    return (
        <>
            <div className="container-fluid mt-5 " >
                <Row className="g-3 container-profile">
                    <Col
                        xs={12}
                        md={3}
                        className="d-flex justify-content-end"
                    >
                        {
                            !userProfile || Object.keys(userProfile).length === 0 ? (
                                <div className="text-center w-100">
                                    <h2>Cargando perfil...</h2>
                                </div>
                            ) : (
                                <Card className="profile-card w-100">
                                    <Card.Body className="text-center">
                                        <Card.Img
                                            variant="top"
                                            src={mariela}
                                            alt="Imagen de Perfil"
                                            className="profile-imgen"
                                        />
                                        <Card.Title className="mt-3">{user.name}</Card.Title>
                                        <Card.Text>{user.email}</Card.Text>
                                        <Card.Text>{user.phone}</Card.Text>
                                        <Card.Text>Mis Cursos: Sibo</Card.Text>
                                        <Card.Text>Fecha de Nacimiento: {user.birthdate ? user.birthdate.slice(0, 10) : 'No disponible'}</Card.Text>
                                        <Card.Text>País: {userProfile.country || 'No disponible'}</Card.Text>
                                        <div className="d-flex flex-column align-items-center">
                                            <Button className="m-4" onClick={() => setModal(true)}>Actualizar Perfil</Button>
                                            <Button className="mt-2" onClick={handleLogout}>Cerrar sesión</Button>
                                        </div>
                                    </Card.Body>
                                </Card>
                            )
                        }
                    </Col>
                    <Col
                        xs={12}
                        md={8}
                    >
                        <Row>
                            {userCourses.length > 0 ? (
                                userCourses.map((course, index) => (
                                    <Col xs={12} sm={4} className="mb-4" key={index}>
                                        <Card className="first-card h-100">
                                            <Card.Img className="course-imag" src={course.image} alt={course.title} />
                                            <Card.Body className="d-flex flex-column align-items-center">
                                                <Card.Title>{course.title}</Card.Title>
                                                <Card.Text>{course.description}</Card.Text>
                                                {/* <NavLink to={'/course/'}> */}
                                                    <Button className="btn-custom" onClick={() => navigate(`/course/${course.id}`)}>
                                                        Comenzar
                                                    </Button>
                                                {/* </NavLink> */}
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                ))
                            ) : (
                                <Col className="text-center">
                                    <h2 className="pb-2">No tienes cursos inscritos</h2>
                                    <NavLink to="/course">
                                        <Button className="btn-custom">
                                            Explorar Cursos
                                        </Button>
                                    </NavLink>
                                </Col>
                            )}
                        </Row>
                    </Col>
                    
                </Row>
            </div >
            <Modal
                isVisible={isModal}
                onClose={() => setModal(false)}
                title={"Actualizar Perfil"}
                footer={
                    <Button
                        onClick={() => handleUpdateProfile()}>
                        Actualizar
                    </Button>
                }
            >
                {
                    userProfile ? (
                        <form className="profile-form">
                            <div className="row mb-3">
                                <div className="form-group col-md-6">
                                    <label htmlFor="name"><strong>Nombre:</strong></label>
                                    <input
                                        id="name"
                                        type="text"
                                        name="firstName"
                                        className="form-control"
                                        value={userData.firstName || ''}
                                        onChange={handleChange}
                                    ></input>
                                </div>
                                <div className="form-group col-md-6">
                                    <label htmlFor="lastName"><strong>Apellido:</strong></label>
                                    <input
                                        id="lastName"
                                        name="lastName"
                                        type="text"
                                        className="form-control"
                                        value={userData.lastName || ''}
                                        onChange={handleChange}
                                    ></input>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="form-group col-md-6">
                                    <label htmlFor="email"><strong>Email:</strong></label>
                                    <input
                                        id="email"
                                        type="email"
                                        name="email"
                                        className="form-control"
                                        value={userData.email || ''}
                                        readOnly
                                    ></input>
                                </div>
                                <div className="form-group col-md-3">
                                    <label htmlFor="phone"><strong>Telefono:</strong></label>
                                    <input
                                        id="phone"
                                        type="text"
                                        name="phone"
                                        className="form-control"
                                        value={userData.phone || ''}
                                        onChange={handleChange}
                                    ></input>
                                </div>
                                <div className="form-group col-md-3">
                                    <label htmlFor="gender"><strong>Género:</strong></label>
                                    <select
                                        id="gender"
                                        name="gender"
                                        className="form-control"
                                        value={userData.gender || ''}
                                        onChange={handleChange}
                                    >
                                        <option value="" disabled>Seleccione una opción</option>
                                        <option value="Masculino">Masculino</option>
                                        <option value="Femenino">Femenino</option>
                                        <option value="Otro">Otro</option>
                                    </select>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="form-group col-md-4">
                                    <label htmlFor="birthDate"><strong>Fecha de Nacimiento:</strong></label>
                                    <input
                                        id="birthDate"
                                        type="date"
                                        name="birthDate"
                                        className="form-control"
                                        value={userData.birthDate ? userData.birthDate.slice(0, 10) : ''}
                                        onChange={handleChange}
                                    ></input>
                                </div>
                                <div className="form-group col-md-4">
                                    <label htmlFor="country"><strong>País:</strong></label>
                                    <input
                                        id="country"
                                        type="text"
                                        name="country"
                                        className="form-control"
                                        value={userData.country || ''}
                                        onChange={handleChange}
                                    ></input>
                                </div>
                                <div className="form-group col-md-4">
                                    <label htmlFor="avatar"><strong>Avatar:</strong></label>
                                    <input
                                        id="avatar"
                                        type="file"
                                        className="form-control-file"
                                        onChange={e => setUserData({
                                            ...userData,
                                            avatar: e.target.files[0]
                                        })}
                                    ></input>
                                </div>
                            </div>
                            <label htmlFor="bio"><strong>Biografía:</strong></label>
                            <textarea
                                id="bio"
                                name="bio"
                                className="form-control"
                                rows="3"
                                value={userData.bio || ''}
                                onChange={handleChange}
                            ></textarea>
                        </form>
                    ) : (
                        <p>Cargando información del usuario...</p>
                    )
                }
            </Modal>
        </>
    );
};

export default Profile;
